import { createContext } from 'react';

const DateTimePicker = createContext(null);

export default DateTimePicker;
